module.exports = __webpack_public_path__ + "static/img/footer.aaf9018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer.jpg
// module id = 5iLX
// module chunks = 0